function getStatusBackground(status: string): string {

    return status == 'ANNULLATO' || status == 'CANCELLED' ||
      status == 'RITARDO' || status == 'DELAY' ?
        'bg-red' : 'bg-lightblue';
  }

export default getStatusBackground;
